import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  archiveWrapper: {
    background: theme.palette.grey.grey100,
    width: '100%',
    height: 'fit-content',
    borderRadius: '10px',
    padding: '15px',
  },
  generalInfos: {
    display: 'flex',
    alignItems: 'center',
  },
  archivedItemIcon: {
    width: '28px',
  },
  archivedItemLabel: {
    fontSize: '14px',
    color: theme.palette.grey.grey500,
    fontWeight: 600,
    marginLeft: '8px',
    letterSpacing: '-0.14px',
    lineHeight: '120%',
  },
  archivedItemInfos: {
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 'auto',
    /* '>div': {
       height: 'fit-content'
     }*/
  },
  archivedItemInfo: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '12px',

    '& span': {
      fontSize: '12px',
      color: theme.palette.black.dark,
      marginLeft: '2px',
    },
  },
  archivedUpdatedBy: {
    whiteSpace: 'nowrap',
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  motif: {
    marginTop: '9px'
  },
  motifLabel: {
    color: theme.palette.grey.grey400,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '130%',
    marginBottom: '5px'
  },
  motifText: {
    fontSize: '12px',
    lineHeight: '130%',
    color: theme.palette.grey.grey700
  }
}));

export default useStyles;
